import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
import { useTranslation } from 'react-i18next'
import './index.css'
import './kendo_override.css'
import './rtl.css'
import { store } from 'app/store'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import NavigateSetter from 'routes/NavigateSetter'
import I18nConfig from 'locales/config'
import { captureHandledError, getIsSentryEnabled, initSentry } from 'utils/sentry'

const isSentryEnabled = initSentry()

const container = document.getElementById('root') as HTMLElement

const root = ReactDOM.createRoot(container, {
  onRecoverableError: (error, errorInfo) => {
    console.warn('Recoverable React error:', error, errorInfo.componentStack)

    if (getIsSentryEnabled()) {
      captureHandledError(error, {
        tags: {
          source: 'react.recoverable_error',
        },
        extra: {
          componentStack: errorInfo.componentStack,
        },
      })
    }
  },
})

function ErrorFallback() {
  const { t } = useTranslation()

  return (
    <div style={{ padding: 24 }}>
      <h2>{t('ERROR_FALLBACK_TITLE')}</h2>
      <p>{t('ERROR_FALLBACK_DESCRIPTION')}</p>
    </div>
  )
}

const AppTree = (
  <Provider store={store}>
    <BrowserRouter>
      <I18nConfig />
      <App />
      <NavigateSetter />
    </BrowserRouter>
  </Provider>
)

root.render(
  isSentryEnabled ? (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      {AppTree}
    </Sentry.ErrorBoundary>
  ) : (
    AppTree
  ),
)

reportWebVitals()